import { actions } from 'data'
import { ChangePasswordFormType } from 'data/Form/ChangePassword/types'
import { ForgotPasswordFormType } from 'data/Form/ForgotPassword/types'

const asyncValidatePassword = (
  values: ChangePasswordFormType | ForgotPasswordFormType,
  dispatch,
  props: { form: string },
  field: string
) =>
  new Promise<void>((resolve, reject) => {
    if (field === 'newPassword') {
      dispatch(actions.form.validatePassword(values, resolve, reject, props.form))
    } else {
      resolve()
    }
  })

export default asyncValidatePassword
